<template>
  <FetchSmartReadWidget
    v-for="(meterpoint, index) in smartMeters"
    :key="index"
    :meterpoint="meterpoint"
    :class="{ 'mt-4': index > 0 }"
    data-testid="fetch-smart-reads-widget"
  />
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { MeterpointService } from "@/services/MeterpointService"
  import FetchSmartReadWidget from "@/views/customer/meterpoints/components/FetchSmartReadWidget.vue"

  export default defineComponent({
    components: {
      FetchSmartReadWidget,
    },
    data() {
      return {
        current: useCurrentAccountStore(),
        MeterpointService,
      }
    },
    computed: {
      smartMeters() {
        return this.current.meterpoints.data.filter(
          (meterpoint) => meterpoint.hasSmartMeter,
        )
      },
    },
  })
</script>
